<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="priceChangeDetails">
            <van-nav-bar
                title="价格变更详情"
                left-text="价格变更表"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <div class="boxBorder">
                    <van-cell
                        :value="contractInfoData.contract_no"
                        title="合同编号："
                        :icon="require('@/assets/images/icons/icon_gy_1.png')"
                    ></van-cell>
                </div>
                <template v-for="(item,index) in rawMaterial">
                    <div class="boxBorder" :key="index">
                        <van-cell
                            :value="item.type_name"
                            title="原材料名称："
                            :icon="require('@/assets/images/icons/icon_gy_3.png')"
                        ></van-cell>
                        <van-cell
                            :value="item.child_type_name"
                            title="原材料子类："
                            :icon="require('@/assets/images/icons/icon_gy_3.png')"
                        ></van-cell>
                        <van-cell
                            :value="item.spec_name"
                            title="原材料型号："
                            :icon="require('@/assets/images/icons/icon_gy_5.png')"
                        ></van-cell>
                        <van-cell
                            :value="item.unit_price_before"
                            title="原合同价格："
                            :icon="require('@/assets/images/icons/icon_26.png')"
                        ></van-cell>
                        <van-cell
                            :value="item.unit_price"
                            title="变更后价格："
                            :icon="require('@/assets/images/icons/icon_26.png')"
                        ></van-cell>
                        <van-cell
                            :value="item.station_name"
                            title="相关站点："
                            :icon="require('@/assets/images/icons/icon_gy_2.png')"
                        ></van-cell>
                        <van-cell
                            :value="item.effective_date"
                            title="生效时间："
                            :icon="require('@/assets/images/icons/icon_gy_7.png')"
                        ></van-cell>
                    </div>
                </template>
                <div class="boxBorder">
                    <van-cell
                        :value="contractInfoData.remarks?contractInfoData.remarks:'无备注信息'"
                        title="备注："
                        :icon="require('@/assets/images/icons/icon_gy_4.png')"
                    ></van-cell>
                </div>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 价格变更详情
    name: 'price-change-details',
    components: {},
    props: {},
    data() {
        return {
            // 合同信息数据
            contractInfoData: {},
            // 原材料数据
            rawMaterial: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        // 合同信息数据
        this.contractInfoData = this.$route.params.data;
        // 获取原材料数据
        this.getRawMaterial();
    },
    activated() {},
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 获取原材料数据
        getRawMaterial() {
            this.$axios
                .get(`/interfaceApi/Procurement/material/price/adjust/getdetailpage?mpaid=${this.contractInfoData.id}`)
                .then(res => {
                    if (res.rows.length > 0) {
                        this.rawMaterial = res.rows;
                    }
                })
                .catch(error => {
                    this.$toast({ message: error.ErrorCode.Message });
                });
        },
    },
};
</script>
<style lang="stylus">
.priceChangeDetails
    height 100%
    section
        height calc(100% - 45rpx)
        -webkit-overflow-scrolling: touch;
        overflow: scroll;
        .boxBorder
            border-bottom 15rpx solid #F0F0F0
        .van-cell
            display flex
            .van-cell__title
                flex 1
            .van-cell__value
                flex 2
            &:not(:last-child)::after
                left 0
</style>